import { useMemo, useState, useCallback, useEffect } from "react";
import { Modal, Frame, TitleBar, Button } from "@react95/core";

import { contract, Tab, Tabs, Tree, Checkbox, Dropdown, Fieldset, Input } from "@react95/core";

import {
  Regedit,
  Regedit205,
  Regedit206,
  FilePick,
  Mailnews8,
  Mcm3200,
  Wmsui323936,
  Computer,
  Drvspace3,
  Inetcpl1312,
  Systray306,
  Defrag6,
  CurvesAndColors100,
  Charmap1,
  CdMusic,
  Main100,
  ReaderCd,
  Msnp32ServerIcon,
  Phone2,
  Computer3,
  Systray210,
  Gcdef100,
} from "@react95/icons";

import { PCICard } from "../UI/IconImage";

import { useApp } from "../../context/AppContext";
import { useSecret } from "../../context/SecretContext"; // `clickGPU` and `hasClickedGPU`

import { WINDOW_NAMES } from "../../config/const";
import { getModalSizeProps } from "../../config/window";

export const SystemPropertiesDef = {
  id: WINDOW_NAMES.SystemProperties,
  title: "System Properties",
  hasButton: false,
};

function GPUText() {
  const { clickGPU, hasClickedGPU } = useSecret();
  const [clicks, setClicks] = useState(0);

  const handleClick = useCallback(() => {
    if (hasClickedGPU) return;

    setClicks((c) => {
      const next = c + 1;
      if (next >= 10) {
        // activate secret silently
        try {
          clickGPU();
        } catch (err) {
          console.error("failed to send gpu click:", err);
        }
        // reset counter silently
        return 0;
      }
      return next;
    });
  }, [clickGPU, hasClickedGPU]);

  return (
    <span onClick={handleClick} style={{ userSelect: "none" }}>
      GeForce RTX 5090 Aorus Master 32GB
    </span>
  );
}

export default function SystemProperties() {
  const { closeModal } = useApp();
  // const icon = useMemo(() => SystemPropertiesDef.icon, []);
  const sizeProps = useMemo(() => getModalSizeProps("485px", "400px", "centered"), []);

  const treeNodeData = [
    {
      id: 1,
      label: "CD ROM",
      icon: <ReaderCd variant="16x16_4" />,
      children: [
        {
          id: 1,
          label: "IDE CD ROM Drive",
          icon: <ReaderCd variant="16x16_4" />,
        },
      ],
    },
    {
      id: 2,
      label: "Disk Drives",
      icon: <Drvspace3 variant="16x16_4" />,
      children: [
        {
          id: 1,
          label: "SemSung 840 EVO 1 PB NVMe SSD",
          icon: <Drvspace3 variant="16x16_4" />,
        },
        {
          id: 2,
          label: "Crusair SD600 ELITE 512 TB NVMe SSD",
          icon: <Drvspace3 variant="16x16_4" />,
        },
        {
          id: 3,
          label: "SemSung 670 Pro 512 TB NVMe SSD",
          icon: <Drvspace3 variant="16x16_4" />,
        },
      ],
    },
    {
      id: 3,
      label: "Display Adapters",
      icon: <CurvesAndColors100 variant="16x16_4" />,
      children: [
        {
          id: 1,
          label: "Standard Display Adapter (VGA)",
          icon: <CurvesAndColors100 variant="16x16_4" />,
        },
        {
          id: 2,
          label: "GeForce RTX 5090 Aorus Master 32GB",
          icon: <CurvesAndColors100 variant="16x16_4" />,
        },
      ],
    },
    {
      id: 4,
      label: "Floppy disk controllers",
      icon: <Defrag6 variant="16x16_4" />,
      children: [
        {
          id: 1,
          label: "Standard Floppy Disk Controller",
          icon: <Defrag6 variant="16x16_4" />,
        },
      ],
    },
    {
      id: 5,
      label: "Hard disk controllers",
      icon: <Defrag6 variant="16x16_4" />,
      children: [
        {
          id: 1,
          label: "Standard IDE Hard Disk Controller",
          icon: <Defrag6 variant="16x16_4" />,
        },
      ],
    },
    {
      id: 6,
      label: "Keyboard",
      icon: <Charmap1 variant="16x16_4" />,
      children: [
        {
          id: 1,
          label: "PC/AT Enhanced Keyboard (101/102-Key)",
          icon: <Charmap1 variant="16x16_4" />,
        },
      ],
    },
    {
      id: 7,
      label: "Monitor",
      icon: <Computer3 variant="16x16_4" />,
      children: [
        {
          id: 1,
          label: "Generic PnP Monitor",
          icon: <Computer3 variant="16x16_4" />,
        },
        {
          id: 2,
          label: "Generic PnP Monitor",
          icon: <Computer3 variant="16x16_4" />,
        },
        {
          id: 3,
          label: "Generic PnP Monitor",
          icon: <Computer3 variant="16x16_4" />,
        },
      ],
    },
    {
      id: 8,
      label: "Mouse",
      icon: (
        <Main100
          variant="32x32_4"
          style={{
            width: "16px",
            height: "16px",
          }}
        />
      ),
      children: [
        {
          id: 1,
          label: "Generic Serial Mouse",
          icon: (
            <Main100
              variant="32x32_4"
              style={{
                width: "16px",
                height: "16px",
              }}
            />
          ),
        },
      ],
    },
    {
      id: 9,
      label: "Network adapters",
      icon: <PCICard />,
      children: [
        {
          id: 1,
          label: "25 GbE Network Adapter",
          icon: <PCICard />,
        },
        {
          id: 2,
          label: "25 GbE Network Adapter",
          icon: <PCICard />,
        },
        {
          id: 2,
          label: "CDMA PCMCIA Adapter",
          icon: <Systray210 variant="16x16_4" />,
        },
      ],
    },
    {
      id: 10,
      label: "Ports (COM & LPT)",
      icon: <Systray306 variant="16x16_4" />,
      children: [
        {
          id: 1,
          label: "Communications Port (COM1)",
          icon: <Systray306 variant="16x16_4" />,
        },
        {
          id: 2,
          label: "Communications Port (COM2)",
          icon: <Systray306 variant="16x16_4" />,
        },
        {
          id: 3,
          label: "Printer Port (LPT1)",
          icon: <Systray306 variant="16x16_4" />,
        },
      ],
    },
    {
      id: 11,
      label: "Sound, video and game controllers",
      icon: <Inetcpl1312 variant="16x16_4" />,
      children: [
        {
          id: 1,
          label: "SoundBlaster 16 ISA",
          icon: <Inetcpl1312 variant="16x16_4" />,
        },
        {
          id: 2,
          label: "Legitech G99 VR Simulator Compatible HOTAS",
          icon: <Gcdef100 variant="16x16_4" />,
        },
      ],
    },
    {
      id: 12,
      label: "System devices",
      icon: <Computer variant="16x16_4" />,
      children: [
        {
          id: 1,
          label: "Direct memory access controller",
          icon: <Computer variant="16x16_4" />,
        },
        {
          id: 2,
          label: "Extended IO Bus",
          icon: <Computer variant="16x16_4" />,
        },
        {
          id: 3,
          label: "IO read data port for ISA PnP enumerator",
          icon: <Computer variant="16x16_4" />,
        },
        {
          id: 4,
          label: "Programmable interrupt controller",
          icon: <Computer variant="16x16_4" />,
        },
        {
          id: 5,
          label: "System board",
          icon: <Computer variant="16x16_4" />,
        },
        {
          id: 6,
          label: "System CMOS real-time clock",
          icon: <Computer variant="16x16_4" />,
        },
      ],
    },
  ];

  const root = {
    id: 0,
    label: "Computer",
    icon: <Computer variant="16x16_4" />,
  };

  return (
    <Modal
      key={SystemPropertiesDef.id}
      id={SystemPropertiesDef.id}
      title={SystemPropertiesDef.title}
      titleBarOptions={[
        <TitleBar.Close key="close" onClick={() => closeModal(SystemPropertiesDef.id)} />,
      ]}
      defaultClosed={true}
      hasWindowButton={false}
      dragOptions={sizeProps.dragOptions}
      height={sizeProps.height}
      width={sizeProps.width}
      buttons={[
        {
          value: "OK",
          onClick: () => closeModal(SystemPropertiesDef.id),
        },
        {
          value: "Cancel",
          onClick: () => closeModal(SystemPropertiesDef.id),
        },
      ]}
    >
      <Modal.Content style={{ padding: contract.space[6] }}>
        <Tabs defaultActiveTab="General">
          <Tab title="General">
            <div style={{ display: "flex", gap: 0 }}>
              <div style={{ width: 180, marginTop: 40, flexShrink: 0, textAlign: "center" }}>
                <img
                  src="./system-properties.png"
                  alt="System Properties"
                  style={{ maxWidth: "120px" }}
                />
              </div>

              <div
                style={{
                  flex: 1,
                  display: "flex",
                  padding: "10px",
                  flexDirection: "column",
                  gap: "20px",
                  lineHeight: "1.6",
                }}
              >
                <div>
                  <p>System:</p>
                  <p style={{ marginLeft: "8px" }}>DomSoft Windoze 93 Pro</p>
                  <p style={{ marginLeft: "8px" }}>4.1337.69.420 B</p>
                  <p style={{ marginLeft: "8px" }}>DomSoft Plus+ for Windoze 93</p>
                </div>
                <div>
                  <p>Registered to:</p>
                  <p style={{ marginLeft: "8px" }}>Dom "DomDom"</p>
                </div>
                <div>
                  <p>Computer:</p>
                  <p style={{ marginLeft: "8px" }}>Pentium 133 MHz</p>
                  <p style={{ marginLeft: "8px" }}>32.0MB RAM</p>
                  {/* gpu clickable: 10 clicks activates secret */}
                  <p style={{ marginLeft: "8px" }}>
                    <GPUText />
                  </p>
                </div>
              </div>
            </div>
          </Tab>

          <Tab title="Device Manager">
            <Frame
              bgColor="white"
              boxShadow="$in"
              style={{
                margin: "0px",
                padding: "2px",
                width: "100%",
                height: "100%",
                overflowY: "auto",
                minWidth: "115px",
              }}
            >
              <Tree root={root} data={treeNodeData} />
            </Frame>
          </Tab>
        </Tabs>
      </Modal.Content>
    </Modal>
  );
}
